import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { HttpClientService, UtilityService } from './';

@Injectable()
export class LicensePricingService {

  constructor(private http: HttpClient, private httpClientService: HttpClientService, private utilityService: UtilityService) { }

  // pricing update for given qty
  getPricingDetailsByQty(data) {
    const serviceUrl = this.utilityService.getEnvConfig().getPricingUpdateForDCMcode;
    return this.httpClientService.authorizedPost(serviceUrl, data)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
        this.httpClientService.updateAuthorizationHeaders(res);
        return res.body;
      })
      ,catchError( this.handleError ));
  }

  // decrease qty validation
  decreaseQtyValidation(serviceUrl, data) {
    return this.httpClientService.authorizedPut(serviceUrl, data)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(res);
        return res.body;
      })
      ,catchError( this.handleError ));
  }

  // get pricing for owned product
  getPricingForOwenedQty(data) {
    const serviceUrl = this.utilityService.getEnvConfig().getPricingForOwnedProduct;
    return this.httpClientService.authorizedPost(serviceUrl, data)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(res);
        return res.body;
      }),catchError( this.handleError ));
  }

  handleError = (error) => {
    return throwError(error);
  }

}
